"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserPhotoLayers = void 0;
const UserPhotoLayer_1 = require("../../models/layers/UserPhotoLayer");
const compareByReadingOrder_1 = __importDefault(require("../layers/compareByReadingOrder"));
const getUserPhotoLayers = (p, excludedTypes) => {
  const orderedUserPhotoLayers = [];
  p.printableGroups.filter(pg => !(excludedTypes === null || excludedTypes === void 0 ? void 0 : excludedTypes.includes(pg.type || '')) && pg.qty > 0).forEach(pg => pg.printables.forEach(printable => {
    const printableUserPhotoLayers = printable.layers.filter(UserPhotoLayer_1.isUserPhotoLayer);
    // Make sure they are all ordered left to right, top to bottom
    printableUserPhotoLayers.sort(compareByReadingOrder_1.default);
    orderedUserPhotoLayers.push(...printableUserPhotoLayers.map(layer => ({
      printableGroupId: pg.id,
      rotateWorkspace: !!pg.rotateWorkspace,
      isCompositeDesign: !!printable.isCompositeDesign,
      printableId: printable.id,
      printableEntityKey: printable.id + '__' + printable.version,
      layer
    })));
  }));
  return orderedUserPhotoLayers;
};
exports.getUserPhotoLayers = getUserPhotoLayers;